export default __webpack_public_path__ + "static/media/TheinhardtPan-Regular.95123dde.otf";